import { render, staticRenderFns } from "./request-list.vue?vue&type=template&id=e640e14a&scoped=true&"
import script from "./request-list.vue?vue&type=script&lang=js&"
export * from "./request-list.vue?vue&type=script&lang=js&"
import style0 from "./request-list.vue?vue&type=style&index=0&id=e640e14a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e640e14a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
